import { render, staticRenderFns } from "./stockMovementFilterBox.vue?vue&type=template&id=616951ee&"
import script from "./stockMovementFilterBox.vue?vue&type=script&lang=ts&"
export * from "./stockMovementFilterBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports